import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class WhatsappOAuthService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.WHATSAPP_OAUTH = '/api/whatsapp-oauth';

        this.LOGIN = '/login';
        this.CONNECT_AND_GET_BUSINESSES = '/connect-businesses';
        this.GET_WHATSAPP_ACCOUNTS = '/get-waba';
        this.CONNECT = '/connect';
    }

    async oAuthLogin() {
        try {
            let url = window.location.origin + this.WHATSAPP_OAUTH + this.LOGIN;
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async connectWhatsappAndGetBusinesses(bodyStr) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.WHATSAPP_OAUTH + this.CONNECT_AND_GET_BUSINESSES;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getWhatsappBusinessAccounts(bodyStr) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.WHATSAPP_OAUTH + this.GET_WHATSAPP_ACCOUNTS;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async connectWhatsapp(bodyStr) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.WHATSAPP_OAUTH + this.CONNECT;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyStr)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default WhatsappOAuthService;
